export default "__VITE_ASSET__bsxtZjCI__"